import { mapActions, mapGetters } from 'vuex';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import socialLevelMixin from '@/mixins/socialLevel';

const PROGRESS_LEFT_RIGHT_THRESHOLD = 15;

export default {
  mixins: [socialLevelMixin],
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    avatarTheme() {
      return this.isLayoutDesktop ? 'large' : '';
    },
    username() {
      return this.userData && this.userData.userName ? `${this.userData.userName}` : '';
    },
    backgroundModifiers() {
      const num = this.level.num;
      return {
        'account-social-badge': true,
        // [`account-social-badge--level-${num}`]: num,
      };
    },
    progressBarStyleModifiers() {
      return {
        width: `${this.progressPercentage}%`,
      };
    },
    progressBarClassModifiers() {
      return {
        'account-social-badge__progress-num': true,
        'account-social-badge__progress-num--right  ': true,
      };
    },
    levelColor() {
      return '#55575A';
    },
    progressColor() {
      return '#259EBB';
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    showBadgesPopup() {
      this.setCurrentSmallPopup(MODALS.SMALL_BADGES);
    },
  },
};
